import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const MeetMazenSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-stone-100 to-stone-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight">
              Meet Mazen
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed">
              Mazen is a top-performing real estate professional in Washington, having successfully closed millions in sales. Known for a client-first approach and unwavering attention to detail, he delivers a level of service and results that clients can trust—every time.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              <Link to="/about">
                <Button 
                  variant="outline" 
                  size="lg"
                  className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-full px-8"
                >
                  LEARN MORE ABOUT MAZEN
                </Button>
              </Link>
              <Link to="/contact">
                <Button 
                  variant="outline" 
                  size="lg"
                  className="border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white transition-all duration-300 rounded-full px-8"
                >
                  CONTACT
                </Button>
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative overflow-hidden rounded-lg shadow-2xl">
              <img
                src="/images/mazen-meet.jpg"
                loading="lazy"
                alt="Mazen El-Majzoub, real estate agent serving Tacoma, Seattle, and the greater Puget Sound region"
                width="700"
                height="600"
                className="w-full h-[600px] object-cover transform hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MeetMazenSection;
